/*
 * @Description: bi有关api
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import { BaseService } from './base-service';

class BiService extends BaseService {
  //获取数据来源
  getEntity(params) {
    return this.request({
      method: 'get',
      url: `bi/option/entity/list`,
      params
    });
  }
  //获取实体下的字段
  getEntityField(params) {
    return this.request({
      method: 'get',
      url: `bi/option/field/list`,
      params: { apiIndex: `${Math.random() * 100}`, ...params }
    });
  }
  //新建图表--应用
  getChartData(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/use`,
      data
    });
  }
  //查询图表
  getChartInfo(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/data/info`,
      params: { apiIndex: `${data.chartId}` },
      data
    });
  }
  //查询图表配置信息
  getChartConfigInfo(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/config/info`,
      params: { apiIndex: `${data.chartId}` },
      data
    });
  }
  //新建图表
  creatChart(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/save`,
      data
    });
  }
  //新建图表
  updateChart(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/update`,
      data
    });
  }
  // 删除仪表盘
  deleteDashboard(data) {
    return this.request({
      method: 'post',
      url: `bi/dashboard/delete`,
      data
    });
  }
  // zzh
  //图表列表
  getChartList(params) {
    return this.request({
      method: 'get',
      url: `bi/chart/list`,
      params
    });
  }
  // 图表库编辑权限
  updateChartPermission(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/updatePermission`,
      data
    });
  }
  //新增仪表盘
  creatDashboard(data) {
    return this.request({
      method: 'post',
      url: `bi/dashboard/save`,
      data
    });
  }
  //修改仪表盘
  updateDashboard(data) {
    return this.request({
      method: 'post',
      url: `bi/dashboard/update`,
      data
    });
  }
  //获取仪表盘列表
  getDashboardList(params) {
    return this.request({
      method: 'get',
      url: `bi/dashboard/list`,
      params
    });
  }

  // 获取带状态仪表盘列表
  getDashboardSortList(params) {
    return this.request({
      method: 'get',
      url: `bi/dashboard/get/sort`,
      params
    });
  }
  // 保存带状态仪表盘列表
  saveDashboardSortList(data) {
    return this.request({
      method: 'post',
      url: `bi/dashboard/save/sort`,
      data
    });
  }
  //获取仪表盘详情
  getDashboardInfo(params) {
    return this.request({
      method: 'get',
      url: `bi/dashboard/info`,
      params: { apiIndex: `${params.dashboardId}`, ...params }
    });
  }
  //  删除图表
  delChart(data) {
    return this.request({
      method: 'post',
      url: `bi/chart/delete`,
      data
    });
  }

  /**
   * @brief 图表数据下钻
   * @date 2024年07月03日17:11:49
   * @author zl
   */
  getChartDrill(data) {
    return this.request({
      method: 'post',
      url: `/bi/chart/data/drill/down`,
      data
    });
  }

  /**
   * @brief 导出excel
   * @param data
   * @return {*}
   */
  dataExport(params) {
    return this.request({
      method: 'get',
      url: `/bi/chart/export`,
      responseType: 'blob',
      params
    });
  }

  /**
   * @brief 导出excelV2
   * @param data
   * @return {*}
   */
  dataExportV2(data) {
    return this.request({
      method: 'post',
      url: `/bi/chart/export/v2`,
      responseType: 'blob',
      data
    });
  }

  // 获取所有实体字段
  getCustomSortInfo(data) {
    return this.request({
      method: 'get',
      url: `bi/option/custom/sort/info`,
      params: data
    });
  }
}

export const biService = new BiService();
